'use strict';

require('picturefill')();

window.is_developing = (
    location.href.indexOf('.site') !== -1 ||
    location.href.indexOf('.devspace.net') !== -1
);

window.is_blocksoffice = (
    location.href.indexOf('tickets.') !== -1
);

var common = require('./bootstraps/common');
common.init();

var widgets = require('./bootstraps/widgets');
widgets.init();



// WEBPACK FOOTER //
// ./main.js